import type { ITimeScaleApi, Time } from 'lightweight-charts';

/**
 * Chart shift, as MT5 calls it: the share of the chart's width left empty to
 * the right of the newest bar, so the latest candle sits clear of the price
 * scale instead of pressed against it.
 *
 * Setting a visible range also sets the time scale's right offset, which the
 * chart then keeps as new bars arrive — so the gap survives live updates.
 */
export const CHART_SHIFT = 0.075;

/** Empty bars to add after `span` visible bars so they fill CHART_SHIFT of the width. */
export function shiftBars(span: number): number {
  return Math.max(3, Math.round((span * CHART_SHIFT) / (1 - CHART_SHIFT)));
}

/** Show the newest `visibleBars` bars, ending at `lastIndex`, with the shift. */
export function showLatest(ts: ITimeScaleApi<Time>, lastIndex: number, visibleBars: number): void {
  const from = Math.max(0, lastIndex - visibleBars);
  ts.setVisibleLogicalRange({ from, to: lastIndex + shiftBars(lastIndex - from) });
}

/** Fit the whole series, then add the shift. */
export function fitWithShift(ts: ITimeScaleApi<Time>): void {
  ts.fitContent();
  const range = ts.getVisibleLogicalRange();
  if (!range) return;
  ts.setVisibleLogicalRange({ from: range.from, to: range.to + shiftBars(range.to - range.from) });
}
